import React, { useState } from 'react';
import { Container } from '../../../components';

const CustomerInfo = ({ proposal }) => {
  const [showLogo, setShowLogo] = useState(false);

  return (
    <div className="basis-1/4">
      {proposal?.customer?.id !== 0 && (
        <Container title={'Customer Information'}>
          <div className="flex flex-col gap-5 p-5">
            <div>
              <strong>Customer Code:</strong> {proposal.customer.customerCode}
            </div>
            <div>
              <strong>Customer Name:</strong> {proposal.customer.customerName}
            </div>
            <div>
              <strong>Contact No:</strong> {proposal.customer.phone}
            </div>
            <div>
              <strong>Email:</strong> {proposal.customer.email}
            </div>
            {proposal?.customer?.customerLogoUrl && (
              <div className="flex items-center gap-2">
                <div className="font-600">Logo :</div>
                <div className="font-300 text-blue-600">
                  <button
                    onMouseEnter={() => setShowLogo(true)}
                    onMouseLeave={() => setShowLogo(false)}
                  >
                    Show Preview
                  </button>
                  {showLogo && (
                    <div className="absolute z-10 right-20 ">
                      <img
                        src={proposal?.customer?.customerLogoUrl}
                        alt="Customer Logo"
                        className="w-64 h-64 rounded-lg"
                      />
                    </div>
                  )}
                </div>
              </div>
            )}{' '}
          </div>
        </Container>
      )}
    </div>
  );
};

export default CustomerInfo;
